var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 534,
    viewBox: "0 0 622 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4818 1.96194C25.2743 55.5701 1.6455 123.193 2.84553 192.668C4.04556 262.142 29.9957 328.909 76.0282 380.958C122.061 433.007 185.155 466.924 253.962 476.607C322.769 486.29 392.773 471.104 451.382 433.78M171.492 86.0841C147.314 115.403 134.391 152.387 135.047 190.384C135.704 228.381 149.896 264.896 175.072 293.363C200.248 321.83 234.755 340.379 272.387 345.675C310.018 350.971 348.305 342.665 380.359 322.252",
    stroke: "#F2F4F3",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M519.178 299.978L387.803 282.621C372.989 280.664 362.637 296.902 370.663 309.506L462.202 453.25C470.228 465.853 489.32 463.341 493.812 449.089L533.649 322.702C536.935 312.276 530.015 301.41 519.178 299.978Z",
    fill: "#FFCC04",
    stroke: "#F2F4F3",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg-1.c3826b508dff12ac9000f52115f8a6ef.svg";
export { ForwardRef as ReactComponent };